import _objectSpread from "/var/www/web-feedback/form-builder/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { defineIntegration } from '@sentry/core';
import { WINDOW } from '../helpers.js';

/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */
var httpContextIntegration = defineIntegration(function () {
  return {
    name: 'HttpContext',
    preprocessEvent: function preprocessEvent(event) {
      // if none of the information we want exists, don't bother
      if (!WINDOW.navigator && !WINDOW.location && !WINDOW.document) {
        return;
      }

      // grab as much info as exists and add it to the event
      var url = event.request && event.request.url || WINDOW.location && WINDOW.location.href;
      var _ref = WINDOW.document || {},
        referrer = _ref.referrer;
      var _ref2 = WINDOW.navigator || {},
        userAgent = _ref2.userAgent;
      var headers = _objectSpread({}, event.request && event.request.headers, referrer && {
        Referer: referrer
      }, userAgent && {
        'User-Agent': userAgent
      });
      var request = _objectSpread({}, event.request, url && {
        url: url
      }, {
        headers: headers
      });
      event.request = request;
    }
  };
});
export { httpContextIntegration };